import { useMutation, useQueryClient } from "@tanstack/react-query"
import { requestAddSubject } from "api/subject.api.ts"
import { useToast } from "hooks/index.js"
import { useState } from "react"
import styled from "styled-components"
import { AppButton } from "ui/base/appButton/AppButton.jsx"
import { HelperText } from "ui/base/helperText/HelperText.jsx"
import { InputSignUp } from "ui/base/InputSignUp/InputSignUp"
import { Modal } from "ui/base/modal/Modal"
import { BlueTicket } from "ui/icons/BlueTicket.jsx"
import { PlusIcon } from "ui/icons/PlusIcon"
import { themeColor } from "ui/theme/index.js"

export const AddSubjectRequest = () => {
  const queryClient = useQueryClient()
  const [open, setOpen] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [value, setValue] = useState("")

  const handleClose = () => setOpen(false)
  const handleCloseSuccess = () => setShowSuccess(false)

  const { mutate } = useMutation({
    mutationFn: requestAddSubject,
    onSuccess: () => {
      handleClose()
      setShowSuccess(true)
      setValue("")
      queryClient.invalidateQueries(["subjects"])
    },
    onError: (err) => {
      useToast("error", error?.response?.data?.message || "Error: getSubjects")
    },
  })

  return (
    <>
      <Container>
        <IconContainer
          style={{ cursor: "pointer" }}
          onClick={() => setOpen(true)}>
          <PlusIcon size={20} color='#554DF1' />
        </IconContainer>

        <HelperText onClick={() => setOpen(true)} style={{ cursor: "pointer" }}>
          Not found? add here
        </HelperText>
      </Container>
      <Modal
        show={open}
        handleClose={handleClose}
        minHeight={200}
        maxWidth={450}>
        <RequestModalContainer>
          <HelperText sizeMobile='regular'>
            Let us know what you want to teach. We will review and let you know
            if we can add it to the app.
          </HelperText>
          <InputSignUp
            value={value}
            setValue={(text) => setValue(text)}
            maxLength={30}
            minLength={3}
            showLimite
            required
          />
          <AppButton
            background='pink'
            variant={value.length < 3}
            disabled={value.length < 3}
            onClick={() => mutate(value)}>
            Send request
          </AppButton>
        </RequestModalContainer>
      </Modal>
      <Modal
        show={showSuccess}
        handleClose={handleCloseSuccess}
        minHeight={200}
        maxWidth={450}>
        <RequestModalContainer>
          <div style={{ display: "grid", placeContent: "center" }}>
            <BlueTicket width={75} height={75} />
          </div>
          <div></div>
          <HelperText center sizeMobile='regular'>
            Thanks! We will inform you by email if we decide to include this class in the platform.
          </HelperText>
          <AppButton onClick={handleCloseSuccess}>OK</AppButton>
        </RequestModalContainer>
      </Modal>
    </>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
`

const IconContainer = styled.div`
  height: ${({ size }) => (size ? size + "px" : "45px")};
  width: ${({ size }) => (size ? size + "px" : "45px")};
  background-color: ${themeColor("lightBlue")};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
`

const RequestModalContainer = styled.div`
  display: grid;
  gap: 1rem;
  width: 100%;
`
